// utils/isUserAuthenticated.ts
import { getCookie } from "./authService";
import { getCSRF } from "./csrf";
import { ROOT_URL } from "./gloableVariables";

export const isUserAuthenticated = (): boolean => {
  const authToken = getCookie("authToken");
  const token = getCookie("token");
  return !!authToken && !!token;
};

export const getUserByCookie = async () => { 

  const csrfToken = await getCSRF();
  const loginPayload = {
    action: "my_bookmark",
    csrf_token: csrfToken,
    token: getCookie("token"),
  };

  const response = await fetch(`${ROOT_URL}web-apis.php`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(loginPayload),
  });

  const data = await response.json();
  return data;
};
